<template lang="pug">
  .notification
    strong Porteador:&nbsp
    | {{ porteador.nombre }}
    br
    strong Clave porteador:&nbsp
    | {{ porteador.clave }}
    br
    strong R.F.C.:&nbsp
    | {{ porteador.rfc }}
</template>

<script>
  export default {
    name: 'CardPorteador',
    props: {
      porteador: {
        type: Object,
        default: {}
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/sca_Componentes/componentes/CardPorteador.vue